import { Box, Title } from "@mantine/core"
import type React from "react"

interface ContentProps {
  title: React.ReactNode
  children: React.ReactNode
}

const Content: React.FC<ContentProps> = ({ title, children }) => {
  return (
    <Box p="md" style={{ minWidth: 710 }}>
      <Title order={3} mb="md">
        {title}
      </Title>
      {children}
    </Box>
  )
}

export default Content
